import React from "react";
import { Box, useMediaQuery } from "@mui/material";
import styles from "./MyLearningWidget.module.scss";
import CustomSkeleton from "./../../../../components/custom-skeleton/CustomSkeleton";

const MyLearningCustomSkeleton: React.FC = () => {
  const isMobile = useMediaQuery("(max-width: 900px)");

  return (
    <Box className={styles.skeletonGroup}>
      {Array.from({ length: isMobile ? 2: 4 }).map((_, index) => (
        <Box key={index} className={styles.card}>
          <CustomSkeleton variant="rectangular" width={"100%"} height={"60%"} />
          <CustomSkeleton variant="rectangular" height={"20%"} width={"100%"} />
          <CustomSkeleton variant="rectangular" height={"20%"} width={"60%"} />
        </Box>
      ))}
    </Box>
  );
};

export default MyLearningCustomSkeleton;


